import type { ReactNode } from 'react'

import { DocumentIcon } from '@gto/icons-react/outline/document'
import { FilmIcon } from '@gto/icons-react/outline/film'
import { FlagIcon } from '@gto/icons-react/outline/flag'
import { PhotoIcon } from '@gto/icons-react/outline/photo'

export const CATEGORY_ICON: Record<string, (props: { className?: string }) => ReactNode> = {
  BANNER: FlagIcon,
  VIDEO: FilmIcon,
  IMAGE: PhotoIcon,
  OTHER: DocumentIcon,
}

export const isImage = (ct: string) => ct.startsWith('image/')
export const isVideo = (ct: string) => ct.startsWith('video/')
